import apis from './apis'
import actions from './actions'
import brands from './brands'
import userRoles from './roles'
import branchTypes from './branchTypes'
import invoiceTypes from './invoiceTypes'
import invoiceStatus from './invoiceStatus'
import saleStatus from './saleStatus'
import saleReturnStatus from './saleReturnStatus'
import commissionStatus from './commissionStatus'
import purchaseTypes from './purchaseTypes'
import purchaseStatus from './purchaseStatus'
import purchaseReturnStatus from './purchaseReturnStatus'
import productionStatus from './productionStatus'
import dispatchStatus from './dispatchStatus'
import movementStatus from './movementStatus'
import retailers from './retailers'

const constants =  {
	apis,
	actions,
	brands,
	userRoles,
	branchTypes,
	invoiceTypes,
	invoiceStatus,
	saleStatus,
	saleReturnStatus,
	commissionStatus,
	purchaseTypes,
	purchaseStatus,
	purchaseReturnStatus,
	productionStatus,
	dispatchStatus,
	movementStatus,
	retailers,
	auth_header_key: 'Auth',//change to Autherization if apache accepts this header
	refresh_token_key: 'refreshToken',
	filterSearchCount: 5,
}

export default constants
